import React from "react";
import { Modal } from "react-bootstrap";
import "./CustomModal.scss";

const CustomModal = ({ show, onClose, title, children, className }) => {
  return (
    <Modal 
      show={show} 
      onHide={onClose} 
      centered 
      className={`custom-modal ${className || ""}`}
      backdropClassName="custom-modal-backdrop"
    >
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

export default CustomModal;
